import ServiceTypes from "./ServiceTypes";

export default ServiceTypes;